module.exports = __webpack_public_path__ + "media/images/station-bd478bab12037e38cb5daf51b48a53d1.png";